import styles from './loading-button.module.css'

import cn from 'clsx'
import React from 'react'
import { Button, Spinner } from 'components/ds'

type Props = React.ComponentProps<typeof Button> & {
  loading?: boolean
  loadingLabel: React.ReactNode
}

const LoadingButton = ({
  loading,
  loadingLabel,
  disabled,
  className,
  children,
  ...buttonProps
}: Props): React.ReactNode => (
  <Button
    disabled={disabled || loading}
    className={cn(styles.FullWidthButton, className)}
    {...buttonProps}
  >
    {loading ? (
      <>
        <Spinner /> {loadingLabel}
      </>
    ) : (
      children
    )}
  </Button>
)

export default LoadingButton
